import { render } from "./MonitoringView.vue?vue&type=template&id=ab82879e&scoped=true&ts=true"
import script from "./MonitoringView.vue?vue&type=script&lang=ts"
export * from "./MonitoringView.vue?vue&type=script&lang=ts"

import "./MonitoringView.vue?vue&type=style&index=0&id=ab82879e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab82879e"]])

export default __exports__